export default __webpack_public_path__ + "static/media/fireFN2.cc0ff059.svg";